import {
  engagement_status_options,
  engagement_type_options,
  engagements,
  finding_category_options,
  finding_rating_options,
  finding_status_options,
  findings_cards,
  findings_rows,
  plan_cards,
  readiness_rows,
  request_cards,
  request_rows,
  request_status_options,
  tabs,
  create_engagement_form,
  create_finding_form,
  create_request_form
} from './audits_data';
import { audit_pack_catalog, drawer_computed, drawer_methods, engagement_drawer_catalog, finding_drawer_catalog } from './audit_drawer';
import { audit_computed, audit_methods } from './audit_helper';

export default {
  name: 'ComplyonAudits',
  data: () => ({
    tabs,
    active_tab: 'plan',
    plan_cards,
    readiness_rows,
    engagements: [...engagements],
    engagement_type_options,
    engagement_status_options,
    request_cards,
    request_rows: request_rows.map((row) => ({ ...row, audit_ref: row.audit_ref || 'AUD-01', status: { ...row.status } })),
    request_status_options,
    findings_cards,
    findings_rows: findings_rows.map((row) => ({ ...row, status: { ...row.status } })),
    finding_category_options,
    finding_rating_options,
    finding_status_options,
    finding_drawer_catalog,
    audit_pack_catalog,
    engagement_drawer_catalog,
    selected_audit_pack_ref: 'AUD-01',
    show_new_engagement_modal: false,
    new_engagement_form: create_engagement_form(),
    active_engagement_drawer: null,
    show_request_modal: false,
    editing_request_ref: null,
    request_form: create_request_form(),
    show_finding_modal: false,
    finding_form: create_finding_form(),
    active_finding_drawer: null
  }),
  computed: {
    ...audit_computed,
    ...drawer_computed
  },
  methods: {
    ...audit_methods,
    ...drawer_methods
  }
};
